// authHelpers.js
export const createHandleProtectedAction = ({
  user,
  isLoggedIn,
  authLoading,
  navigate,
}) => {
  return async (action) => {
    // While auth state is still being resolved, don't run actions
    if (authLoading) {
      return;
    }

    // If user is not logged in or auth is missing, redirect to login
    if (!isLoggedIn || !user) {
      navigate("/login");
      return;
    }

    // If user is logged in but must reset password, force them to that page
    if (user.is_loggedin !== true) {
      navigate("/reset-password");
      return;
    }

    // All checks passed → perform the protected action
    await action();
  };
};